<div style="width: 100%; height: 60px;">
    <div style="float:right; width: 180px; cursor: pointer;" (click)="onEmail()">
        <img src="../../assets/email.png" alt="Share with email" style="width: 48px; height: auto; vertical-align: middle;">
        <span style="vertical-align: middle;font-weight: bold;margin-left:10px; font-size: 22px;">Email</span>
    </div>
</div>

<img [src]=photo alt="" width="100%" height="auto" >